<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :filterData="scopedFilterData"
      withoutEdit
      :apiUrl="apiUrl">

      <template #filter="scope">
        <div class="row">
          <div class="col">
            <v-select
              v-model="scope.data.companyId"
              :options="listOptions.companies"
              :reduce="item => item.ID"
              placeholder="Instansi / OPD"
              @input="onRefresh"
              label="Name"/>
          </div>
        </div>
      </template>

      <template #form="scope">
        <div class="form-group">
          <label>Instansi/OPD</label>
          <v-select
            v-model="scope.data.CompanyID"
            :options="listCompanies"
            :reduce="item => item.ID"
            @input="onSelectCompany"
            label="Name"
          />
        </div>

        <div class="form-group">
          <label>User (Pegawai)</label>
          <v-select
            v-model="scope.data.UserID"
            :options="listUsers"
            :reduce="item => item.ID"
            :get-option-label="option => option.Employee ? option.Employee.Name : option.Username"
            />
            <!-- label="Username" -->
        </div>

        <div class="form-group">
          <label>Lokasi</label>
          <v-select
            v-model="scope.data.LocationID"
            :options="listLocations"
            :reduce="item => item.ID"
            label="Name"/>
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="scopedFilterData"
      :search="search"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()
    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/user-location',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'EmployeeName', label: 'Nama Pegawai' },
        { key: 'CompanyName', label: 'Instansi/OPD' },
        { key: 'LocationName', label: 'Nama Lokasi' },
      ],
      selectedItem: null,
      search: '',
      scopedFilterData: {
        companyId: null,
      },
      scopedFormData: {
        ID: null,
        UserID: null,
        LocationID: null,
      },
      listOptions: {
        companies: [],
      },
      scopedDetailData: {},
      listCompanies: [],
      listUsers: [],
      listLocations: []
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      // const companyId = JSON.parse(localStorage.getItem('userData')).employee.CompanyID

      this.$axios.get('/company').then((res) => {
        this.listCompanies = res.data
        this.listOptions.companies = res.data
      })

      this.$axios.get('/location').then((res) => {
        this.listLocations = res.data
      })
    },

    onSelectCompany (e) {
      const companyId = e

      this.$axios.get('/user?companyId=' + companyId).then((res) => {
        this.listUsers = res.data
      })
    }
  }
}
</script>
